@switch (keywordRating()) {
    @case (DiagnosticRating.GOOD) {
        <ng-container
            [ngTemplateOutlet]="positionRatingTemplate"
            [ngTemplateOutletContext]="{
                icon: Icon.HEART_EYES_CAT,
                subtitle: 'maloupe.diagnostic_keywords.position_text.visible' | translate,
            }">
        </ng-container>
    }
    @case (DiagnosticRating.AVERAGE) {
        <ng-container
            [ngTemplateOutlet]="positionRatingTemplate"
            [ngTemplateOutletContext]="{
                icon: Icon.SMILEY_CAT,
                subtitle: 'maloupe.diagnostic_keywords.position_text.visible' | translate,
            }">
        </ng-container>
    }
    @case (DiagnosticRating.BAD) {
        <ng-container
            [ngTemplateOutlet]="positionRatingTemplate"
            [ngTemplateOutletContext]="{
                icon: Icon.CRYING_CAT_FACE,
                subtitle: 'maloupe.diagnostic_keywords.position_text.not_visible' | translate,
            }">
        </ng-container>
    }
    @default {
        <ng-container
            [ngTemplateOutlet]="positionRatingTemplate"
            [ngTemplateOutletContext]="{
                icon: Icon.CRYING_CAT_FACE,
                subtitle: 'maloupe.diagnostic_keywords.position_text.not_visible' | translate,
            }">
        </ng-container>
    }
}

<ng-template let-icon="icon" let-subtitle="subtitle" #positionRatingTemplate>
    <div class="flex items-center gap-x-2">
        <img class="h-6 w-6 sm:h-4 sm:w-4" [alt]="icon" [src]="icon | imagePathResolver: { folder: 'icons' }" />
        <div class="flex items-center gap-x-1 sm:block sm:leading-none">
            <span
                class="malou-text-13--semibold sm:malou-text-10 text-color-text-title"
                [ngClass]="{
                    'malou-chip--error max-w-fit': shouldShowAsChip() && isBadRanking(),
                }"
                >{{ displayedRating() }}
            </span>
            @if (withSubtitle()) {
                <span class="malou-text-11--regular sm:malou-text-10 text-color-text">{{ subtitle }}</span>
            }
        </div>
    </div>
</ng-template>
